import React, { useState } from 'react'
import { getDashboard, triggerFullCycle, Dashboard } from '../lib/api'
import { useApi } from '../hooks/useApi'
import FeedCard from '../components/FeedCard'

export default function DashboardPage() {
  const { data, loading, refresh } = useApi<Dashboard>(getDashboard)
  const [syncing, setSyncing] = useState(false)

  const handleSync = async () => {
    setSyncing(true)
    try {
      await triggerFullCycle()
      await refresh()
    } finally {
      setSyncing(false)
    }
  }

  if (loading) return <div className="loading">Loading HQ...</div>
  if (!data) return <div className="empty-state"><div className="message">Could not load dashboard</div></div>

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600 }}>What you need to know</h2>
        <button className="sync-btn" onClick={handleSync} disabled={syncing}>
          {syncing ? 'Syncing...' : 'Sync now'}
        </button>
      </div>

      <div className="stats-grid">
        <div className={`stat-card ${data.critical_count > 0 ? 'critical' : ''}`}>
          <div className="value">{data.critical_count}</div>
          <div className="label">Critical</div>
        </div>
        <div className={`stat-card ${data.action_items_stale > 0 ? 'warning' : ''}`}>
          <div className="value">{data.action_items_stale}</div>
          <div className="label">Stale</div>
        </div>
        <div className="stat-card">
          <div className="value">{data.action_items_waiting}</div>
          <div className="label">Waiting on</div>
        </div>
        <div className="stat-card">
          <div className="value">{data.action_items_open}</div>
          <div className="label">Open</div>
        </div>
        <div className="stat-card">
          <div className="value">{data.unseen_count}</div>
          <div className="label">Unseen</div>
        </div>
        <div className={`stat-card ${data.contacts_overdue > 0 ? 'warning' : ''}`}>
          <div className="value">{data.contacts_overdue}</div>
          <div className="label">Overdue contacts</div>
        </div>
      </div>

      <div className="section-header">Recent intelligence</div>

      {data.recent_items.length === 0 ? (
        <div className="empty-state">
          <div className="message">No intelligence yet. Hit Sync to pull your email.</div>
        </div>
      ) : (
        data.recent_items.map((item) => (
          <FeedCard key={item.id} item={item} onAction={refresh} />
        ))
      )}
    </div>
  )
}
